import { createPathfinder } from "./pathfinder";
import Directions from "./directions";
import Random from "rung/src/random";

const rng = new Random(Math.random);

function scatterAndFlee(entity, chaser, stage) {
  console.log(`scatterAndFlee: ${entity.name} is fleeing`);

  let x = Math.sign(chaser.x - entity.x);
  let y = Math.sign(chaser.y - entity.y);

  if (stage.canCharacterMoveTo(x, y) && stage.isUnoccupied(x, y)) {
    stage.moveEntityTo(entity, x, y);
  }
}

function walkTo(entity, target, stage) {
  if (stage.canCharacterMoveTo(target.x, target.y) && stage.isUnoccupied(target.x, target.y)) {
    stage.moveEntityTo(entity, target.x, target.y);
  }
}

function drunkenWalk(entity, stage) {
  //console.log(`drunkenWalk: ${entity.name} is wandering`);

  for (let i=0; i<4; i++) {
    let direction = Directions.CARDINAL[rng.integer(4)];
    let x = entity.x + direction.x;
    let y = entity.y + direction.y;

    if (stage.canCharacterMoveTo(x, y) && stage.isUnoccupied(x, y)) {
      stage.moveEntityTo(entity, x, y);
      break;
    }
  }
}

function meleeCharge(entity, target, stage) {
  //console.log(`meleeCharge: ${entity.name} is charging`);

  const adjacentNodes = (x, y) => stage.adjacentPoints(x, y);
  const costHeuristic = (from, to) => (
    Math.abs(from.x - to.x) + Math.abs(from.y - to.y) * 1.01
  );
  const traversalCost = (x, y) => stage.movementCost(x, y);
  const isTraversable = (x, y) => stage.canMoveTo(x, y);

  const search = createPathfinder(
    adjacentNodes,
    costHeuristic,
    traversalCost,
    isTraversable
  );

  const path = search(
    { x: entity.x, y: entity.y },
    { x: target.x, y: target.y }
  );

  const next = path[0];

  if (stage.isUnoccupied(next.x, next.y)) {
    stage.moveEntityTo(entity, next.x, next.y);
  } else {
    const entities = stage.entitiesAt(next.x, next.y);
    const _target = entities.find(e => e === target);
    if (_target) _target.bumpFrom(entity, stage);
  }
}

function meleeAttack(entity, target, stage) {
  entity.combat.attackBonus
  target.combat.defenceScore
}

function rangedAttack(entity, target, stage) {

}

function yeet(entity, target, stage) {
  console.log(`${entity.name} yeets (something?) at ${target.name}`);

  if (target.isVulnerable()) {
    target.hit(5);
  }
}

export {
  yeet,
  walkTo,
  drunkenWalk,
  meleeCharge,
  scatterAndFlee
}
